export default __webpack_public_path__ + "static/media/a023-startup3-en-short.cebe540b.png";